import Theme from './react-sortable-tree-theme';

export default Theme;
